module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO VERTICAL X-02bcdd216c46e273cbda583e2c96482b.png";